import styled from "styled-components";

export const StyledInput = styled.input`
  width: 100%;
  height: 45px;
  border: none;
  border-bottom: 1px solid #555454;
  font-size: 1.8rem;
  padding-bottom: 1rem;
  margin-bottom: 1rem;

  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0),
    inset 0 0 0 100px rgba(255, 255, 255, 1);

  transition: all 120ms linear;

  :focus {
    border-bottom: 1px solid ${({ theme }) => theme.colors.background};
  }

  @media (max-width: 1600px) {
    font-size: 1.6rem;
    padding-bottom: 1rem;
    margin-top: 1rem;
    height: 30px;
  }

  @media (max-width: 1366px) {
    height: 38px;
    font-size: 1.4rem;
    padding-bottom: 0.5rem;
    margin-top: 0.5rem !important;
    height: 30px;
  }
`;
